import React from "react";
import { TYPE, G } from "../../constants/theme";

export default function Overline({ children, light = false, style = {} }) {
  return (
    <p
      style={{
        ...TYPE.overline,
        color: light ? "rgba(255,255,255,0.45)" : G.gray500,
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
}
